import { GamesData } from "../common/services/tournament.types";

export const games: GamesData = [
    {
      id: "EAFC",
      name: "EAFC",
      image: "/images/games/fc_4.jpeg",
      url: "https://res.cloudinary.com/dwp2kii1e/image/upload/v1753380468/fc_1_imonhw.jpg",
      color: "#4ECDC4",
    },
    {
      id: "Call Of Duty",
      name: "Call of Duty",
      image: "/images/games/cod_2.jpg",
      url: "https://res.cloudinary.com/dwp2kii1e/image/upload/v1753380512/cod_2_yrpph4.jpg",
      color: "#FF6B35",
    },
    {
      id: "PUBG",
      name: "PUBG",
      image: "/images/games/pubg_2.jpg",
      url: "https://res.cloudinary.com/dwp2kii1e/image/upload/v1753380553/pubg_4_eyzxcp.jpg",
      color: "#DDA0DD",
    },
    {
      id: "Tekken",
      name: "Tekken",
      image: "/images/games/tekken_2.jpg",
      url: "https://res.cloudinary.com/dwp2kii1e/image/upload/v1753380582/tekken_2_uzgocm.jpg",
      color: "#96CEB4",
    },
    {
      id: "NBA 2K",
      name: "NBA 2K",
      image: "/images/games/nba_1.jpg",
      url: "https://res.cloudinary.com/dwp2kii1e/image/upload/v1753380626/nba_1_lado4l.jpg",
      color: "#45B7D1",
    },
    {
      id: "Mortal Kombat",
      name: "Mortal Kombat",
      image: "/images/games/mk_2.jpg",
      url: "https://res.cloudinary.com/dwp2kii1e/image/upload/v1753380666/mk_2_xl0rnr.jpg",
      color: "#FFEAA7",
    },
    {
      id: "Fortnite",
      name: "Fortnite",
      image: "/images/games/fortnite_2.jpg",
      url: "https://res.cloudinary.com/dwp2kii1e/image/upload/v1752835873/fornite_brbeom.jpg",
      color: "#FFEAA7",
    },
    {
      id: "eFootball",
      name: "EFootball",
      image: "/images/games/efootball.jpeg",
      url: "https://res.cloudinary.com/dwp2kii1e/image/upload/v1782895363/efootball_dbbqfx.jpg",
      color: "#FF6B35",
    },
  ];
